// extracted by mini-css-extract-plugin
export default {"brandPromo":"AG-z","carousel":"BG-z"};